import { Redirect, Route, Switch } from 'react-router-dom';
import {
  ROUTE_DASHBOARD,
  ROUTE_LOGIN,
  ROUTE_LOGIN_CALLBACK,
  ROUTE_MODULE,
  ROUTE_ROOT,
} from 'utils/routes';
import DashboardPage from 'pages/DashboardPage';
import HomePage from 'components/HomePage';
import { useMsal } from '@azure/msal-react';
import LoginCallback from 'components/LoginCallback';
import App from 'App';

export const PrivateApp = () => {
  const { accounts } = useMsal();

  const isAuthenticated = !!accounts && accounts.length > 0;

  if (!isAuthenticated) {
    return <Redirect to={ROUTE_LOGIN} />;
  }

  return (
    <Switch>
      <Route exact path={ROUTE_LOGIN_CALLBACK} component={LoginCallback} />
      <Route exact path={ROUTE_ROOT} component={HomePage} />
      <Route exact path={ROUTE_DASHBOARD} component={DashboardPage} />
      <Route path={ROUTE_MODULE} component={App} />
    </Switch>
  );
};
